/*
  Vibe Testimonials v1 — WonderSkull custom (not part of stock Shrine PRO).

  Slider engine for the section, scoped to its own .vt markup (no Shrine slider / CDN):
    - Works only when the track is actually scrollable (slide mode); in grid mode it does
      nothing. Re-evaluated on resize so a per-device grid<->slide switch is handled.
    - Arrows page by ~one viewport; Classic mode auto-hides the prev/next at each end
      (position-based). Infinite mode never hides them.
    - Infinite = seamless loop: the whole card set is cloned before AND after the real
      set ([cloneA][real][cloneB]); scroll position is kept inside the real band and
      wrapped by exactly one set-width when it drifts into the clones. Because the clones
      are pixel-identical to the reals, the wrap is invisible.
    - Autoplay advances one card on a timer; pauses on hover/focus and is disabled under
      prefers-reduced-motion. Classic autoplay stops at the last card.
*/
(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function gap(track) {
    var cs = getComputedStyle(track);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  }

  function teardown(root) {
    var s = root._vt;
    if (!s) return;
    if (s.timer) clearInterval(s.timer);
    (s.listeners || []).forEach(function (l) { l[2].removeEventListener(l[0], l[1]); });
    root.querySelectorAll('.vt-card[data-vt-clone]').forEach(function (c) { c.remove(); });
    root._vt = null;
  }

  function setup(root) {
    teardown(root);

    var track = root.querySelector('.vt__track');
    if (!track) return;

    // Only run slider behaviour when the track can actually scroll (i.e. slide mode).
    if (track.scrollWidth <= track.clientWidth + 2) { root._vt = { grid: true }; return; }

    var infinite = root.getAttribute('data-vt-type') === 'infinite';
    var autoplayOn = root.getAttribute('data-vt-autoplay') === 'true' && !REDUCED_MOTION.matches;
    var speed = parseInt(root.getAttribute('data-vt-speed'), 10) || 5000;
    var prev = root.querySelector('[data-vt-prev]');
    var next = root.querySelector('[data-vt-next]');

    var state = { track: track, timer: null, listeners: [] };
    root._vt = state;

    var realCards = Array.prototype.slice.call(track.querySelectorAll('.vt-card:not([data-vt-clone])'));
    var n = realCards.length;
    var firstRealLeft = 0, realWidth = 0;

    function step() {
      var c = track.querySelector('.vt-card');
      return c ? c.getBoundingClientRect().width + gap(track) : track.clientWidth;
    }
    function pageAmount() {
      var s = step();
      return s * Math.max(1, Math.round(track.clientWidth / s));
    }

    if (infinite && n > 0) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      realCards.forEach(function (c) {
        var a = c.cloneNode(true); a.setAttribute('data-vt-clone', ''); a.setAttribute('aria-hidden', 'true');
        var b = c.cloneNode(true); b.setAttribute('data-vt-clone', ''); b.setAttribute('aria-hidden', 'true');
        before.appendChild(a); after.appendChild(b);
      });
      track.insertBefore(before, realCards[0]);
      track.appendChild(after);

      firstRealLeft = realCards[0].offsetLeft;
      var clones = track.querySelectorAll('.vt-card[data-vt-clone]'); // [cloneA...][cloneB...]
      realWidth = clones[n].offsetLeft - firstRealLeft;               // one full set advance
      track.scrollLeft = firstRealLeft;
    }

    function wrap() {
      if (!infinite || realWidth <= 0) return;
      var x = track.scrollLeft;
      if (x >= firstRealLeft + realWidth) track.scrollLeft = x - realWidth;
      else if (x < firstRealLeft) track.scrollLeft = x + realWidth;
    }
    function updateEnds() {
      if (infinite) return;
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('vt--at-start', track.scrollLeft <= 2 || max <= 0);
      root.classList.toggle('vt--at-end', track.scrollLeft >= max - 2 || max <= 0);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; wrap(); updateEnds(); });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    state.listeners.push(['scroll', onScroll, track]);

    function go(dir) {
      track.scrollBy({ left: pageAmount() * dir, behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth' });
    }
    if (prev) { var fp = function () { go(-1); }; prev.addEventListener('click', fp); state.listeners.push(['click', fp, prev]); }
    if (next) { var fn = function () { go(1); }; next.addEventListener('click', fn); state.listeners.push(['click', fn, next]); }

    updateEnds();

    if (autoplayOn) {
      function advance() {
        if (infinite) {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        } else {
          var max = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= max - 2) { stop(); }              // Classic: stop at the end
          else track.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }
      function start() { stop(); state.timer = setInterval(advance, speed); }
      function stop() { if (state.timer) { clearInterval(state.timer); state.timer = null; } }

      var pause = function () { stop(); }, resume = function () { start(); };
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
      state.listeners.push(
        ['mouseenter', pause, root], ['mouseleave', resume, root],
        ['focusin', pause, root], ['focusout', resume, root]
      );
      start();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.vt').forEach(setup);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { document.querySelectorAll('.vt').forEach(setup); }, 200);
  }, { passive: true });

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
